// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__3Kyrg","pageSelectionContainer":"Overview_pageSelectionContainer__38csl"};